import { render, staticRenderFns } from "./lk-success-invite.vue?vue&type=template&id=12f57e6a&"
import script from "./lk-success-invite.vue?vue&type=script&lang=js&"
export * from "./lk-success-invite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/lk-success-invite.vue
// module id = 1660
// module chunks = 0